/* eslint-disable linebreak-style */
import { t } from '../i18n';
import { getLookupLabel } from './lookupLocale';

const FIXED_VALUE_KEYS = {
  ax: {
    mic: 'orderLineForm.small',
    mare: 'orderLineForm.large',
    '32mm': 'orderLineForm.axis32mm'
  },
  actionarestdr: {
    stanga: 'orderLineForm.left',
    dreapta: 'orderLineForm.right'
  }
};

const fixedLabel = (field, value)=>{
  const map = FIXED_VALUE_KEYS[String(field || '').toLowerCase()];
  if (!map) {
    return '';
  }
  const key = map[String(value || '').trim().toLowerCase()];
  return key ? t(key) : '';
};

const sameId = (left, right)=>{
  if (left === undefined || left === null || left === '' || left === 0) {
    return false;
  }
  if (right === undefined || right === null || right === '' || right === 0) {
    return false;
  }
  return String(left) === String(right);
};

const normalizeTipProdus = (value)=> String(value || '').trim().toUpperCase();

const findByKey = (list, id)=>{
  if (!Array.isArray(list)) {
    return null;
  }
  return list.find(item=>item && sameId(item.key, id)) || null;
};

const findByKeyAndTipProdus = (list, id, tipProdus)=>{
  if (!Array.isArray(list)) {
    return null;
  }
  const matches = list.filter(item=>item && sameId(item.key, id));
  if (!matches.length) {
    return null;
  }
  const targetTipProdus = normalizeTipProdus(tipProdus);
  const typedMatch = matches.find(item=>normalizeTipProdus(item.tipProdus) === targetTipProdus);
  return typedMatch || matches[0] || null;
};

const findProdus = (produse, line)=>{
  return findByKeyAndTipProdus(produse, line && line.tipSubprodus, line && line.tipProdus);
};

const findColorInProdus = (produs, id, componentaList)=>{
  const colors = produs && produs.culoriCompatibile;
  if (!Array.isArray(colors)) {
    return null;
  }
  const byKey = colors.filter(item=>item && sameId(item.key, id));
  const byComponenta = byKey.find(item=>componentaList.includes(String(item.componenta || '').toUpperCase()));
  return byComponenta || byKey[0] || null;
};

const findMaterial = (materiale, line)=>{
  if (!Array.isArray(materiale)) {
    return null;
  }
  const matches = materiale.filter(item=>item && sameId(item.key, line.material));
  const typed = matches.find(item=>String(item.tipProdus || '').toUpperCase() === String(line.tipProdus || '').toUpperCase());
  return typed || matches[0] || null;
};

const findColorInMaterial = (materiale, line, colorId)=>{
  const material = findMaterial(materiale, line);
  if (!material) {
    return null;
  }
  return findByKey(material.coduris, colorId);
};

const findOptional = (produs, optionale, line, optionalId)=>{
  const nested = produs && produs.optionaleCompatibile;
  if (Array.isArray(nested)) {
    const matches = nested.filter(item=>item && sameId(item.key, optionalId));
    const byAx = matches.find(item=>!line.ax || !item.ax || String(item.ax) === String(line.ax));
    if (byAx || matches[0]) {
      return byAx || matches[0];
    }
  }
  return findByKeyAndTipProdus(optionale, optionalId, line && line.tipProdus);
};

const labelOf = (entry, fallback)=>{
  if (!entry) {
    return fallback || '';
  }
  return getLookupLabel(entry) || fallback || '';
};

const OPTIONAL_FIELDS = {
  denumireOptional1: 'optional1',
  denumireOptional2: 'optional2',
  denumireOptional3: 'optional3',
  denumireOptional4: 'optional4'
};

const COLOR_FIELDS = {
  denumireCuloareLamela: {
    idField: 'culoareLamela',
    componenta: ['LAMELA', 'COMPONENTA']
  },
  denumireCuloareCaseta: {
    idField: 'culoareCaseta',
    componenta: ['CASETA']
  }
};

export const getOrderLineDisplayLabel = (line, field, lookups = {})=>{
  const fallback = line && line[field] ? line[field] : '';
  if (!line || !field) {
    return fallback;
  }
  const translatedFixedValue = fixedLabel(field, fallback);
  if (translatedFixedValue) {
    return translatedFixedValue;
  }
  const produse = lookups.produse || [];
  const materiale = lookups.materiale || [];
  const optionale = lookups.optionale || [];
  const culori = lookups.culori || [];
  const produs = findProdus(produse, line);

  if (field === 'denumireSubProdus') {
    return labelOf(produs, fallback);
  }
  if (field === 'denumireMaterial') {
    return labelOf(
      (produs && findByKeyAndTipProdus(produs.materialeCompatibile, line.material, line.tipProdus)) || findMaterial(materiale, line),
      fallback
    );
  }
  if (COLOR_FIELDS[field]) {
    const colorId = line[COLOR_FIELDS[field].idField];
    const fromProdus = findColorInProdus(produs, colorId, COLOR_FIELDS[field].componenta);
    const fromMaterial = findColorInMaterial(materiale, line, colorId);
    if (fromProdus || fromMaterial) {
      return labelOf(fromProdus || fromMaterial, fallback);
    }
    const fromCulori = findByKeyAndTipProdus(culori, colorId, line.tipProdus);
    if (fromCulori && fromCulori.codCuloare) {
      return fromCulori.codCuloare;
    }
    return labelOf(fromCulori, fallback);
  }
  if (field === 'denumireTipActionare') {
    return labelOf(
      produs && findByKeyAndTipProdus(produs.actionariCompatibile, line.tipActionare, line.tipProdus),
      fallback
    );
  }
  if (OPTIONAL_FIELDS[field]) {
    return labelOf(findOptional(produs, optionale, line, line[OPTIONAL_FIELDS[field]]), fallback);
  }
  return fallback;
};
